// extracted by mini-css-extract-plugin
module.exports = {"item":"_dd9ab608"};